<template>
  <div class="show-on-hover-parent"
       @click.stop="showDetails">
    <div>{{ formatDateShort(computedObj.signed_at) }}</div>
    <div class="text-muted">{{ formatTime(computedObj.signed_at) }}</div>
    <a class="pointer show-on-hover-child"
       v-if="computedObj.signed_at && canSign">
      <EyeSvg class="svg-gray svg-size-md"/>
    </a>
    <PlanSignModal v-if="showModal"
                   :plan="computedObj"
                   @hidden="showModal = false"/>
  </div>
</template>

<script setup>
import EyeSvg from '@/assets/svg-vue/form/eye.svg'
import { formatDateShort, formatTime } from "@/extensions/filters/filters"
import PlanSignModal from "@/components/parts/planning/PlanSignModal.vue"
import { getCurrentInstance, nextTick, ref, computed } from "vue"
import {useStore} from "vuex"

const props = defineProps({
  object: {
    type: Object
  },
})

const store = useStore()
const instance = (getCurrentInstance())

const showModal = ref(false)
const rights = computed(() => store.state.auth.rights)
const canSign = computed(() => rights.value.includes('sign_plan_treatments'))

const showDetails = async () => {
  if(!canSign.value) return
  showModal.value = true
  await nextTick()
  instance?.ctx?._bv__modal.show('plan-sign-modal')
}

const computedObj = computed(() => {
  return props.object.plan_treatment || props.object
})
</script>
